<template>
  <div
    class="dwp-fixed dwp-bottom-0 dwp-w-full dwp-p-4 dwp-text-xs dwp-flex dwp-items-center dwp-justify-center dwp-m-0"
  >
    <div class="dwp-flex dwp-rounded dwp-items-center dwp-space-x-2">
      <a
        href="https://docketwp.com/"
        target="_blank"
        class="dwp-text-white dwp-opacity-50 dwp-p-1 dwp-leading-none dwp-rounded dwp-font-bold"
      >DocketWP</a>
      <a
        href="https://docketwp.com/support"
        target="_blank"
        @click.prevent="openBeacon"
        class="dwp-text-white dwp-p-1 dwp-leading-none dwp-rounded dwp-font-bold"
      >Support</a>
      <a
        href="mailto:info@docketwp.com"
        target="_blank"
        class="dwp-text-white dwp-p-1 dwp-leading-none dwp-rounded dwp-font-bold"
      >Contact</a>
    </div>
  </div>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  computed: {
    user: get("user/user@data"),
  },

  mounted() {
    !(function (e, t, n) {
      function a() {
        var e = t.getElementsByTagName("script")[0],
          n = t.createElement("script");
        (n.type = "text/javascript"),
          (n.async = !0),
          (n.src = "https://beacon-v2.helpscout.net"),
          e.parentNode.insertBefore(n, e);
      }
      if (
        ((e.Beacon = n = function (t, n, a) {
          e.Beacon.readyQueue.push({ method: t, options: n, data: a });
        }),
        (n.readyQueue = []),
        "complete" === t.readyState)
      )
        return a();
      e.attachEvent
        ? e.attachEvent("onload", a)
        : e.addEventListener("load", a, !1);
    })(window, document, window.Beacon || function () {});
    window.Beacon("init", "54e5d59c-9dd6-4630-883a-3049e8549691");
    Beacon("identify", {
      id: this.user?.id,
      name: this.user?.displayName || this.user?.email,
      email: this.user?.email,
      subscription: this.user?.subscription,
    });
    Beacon("config", {
      display: {
        zIndex: 99999999999,
      },
    });
  },

  methods: {
    openBeacon() {
      Beacon("toggle");
    },
  },
};
</script>